export default __webpack_public_path__ + "static/media/404.278290d2.png";